import React, { Component } from 'react';
import App from "../../App";
import { AiOutlineArrowLeft } from "react-icons/all";
import { Link, withRouter } from "react-router-dom";
import Loader from 'react-loader';
import { getData } from '../../services/baseServices'

class Details extends Component {
    state = {
      riderDetails: {},
      loading: false
    }
  
    componentDidMount() {
        this.setState({ loading: true })
        getData(`riders/${this.props.match.params.id}`)
        .then(res => {
          this.setState({ riderDetails: res?.data, loading: false })
        })
        .catch(errMsg => {
          console.log('Error Message: ', errMsg)
          this.setState({ loading: false })
        });
    }
  
    render() {
      const {riderDetails} = this.state;
      
      return (
        <App layout="">
          <div className="page-header">
            <h2 className="page-title">Rider Details ({riderDetails?.name})</h2>
            <div className="ml-auto">
              <Link to="/rider/list"
                    className="btn btn-sm btn-link mr-2"><AiOutlineArrowLeft/> Back to List</Link>
            </div>
          </div>

          <div className="main-content">
              <Loader loaded={!this.state.loading}>
                  <div className="card-block">
                      <div className="block-body">
                          <table className="info-table">
                              <tbody>
                              <tr>
                                  <td style={{width: '250px'}}>Name</td>
                                  <td style={{width: '20px', textAlign: 'center'}}>:</td>
                                  <td className={`text-bold`}>{riderDetails?.name}</td>
                              </tr>
                              <tr>
                                  <td style={{width: '250px'}}>Phone</td>
                                  <td style={{width: '20px', textAlign: 'center'}}>:</td>
                                  <td>{riderDetails?.phone}</td>
                              </tr>
                              
                              <tr>
                                  <td style={{width: '250px'}}>Email</td>
                                  <td style={{width: '20px', textAlign: 'center'}}>:</td>
                                  <td>{riderDetails?.email}</td>
                              </tr>
                              <tr>
                                  <td style={{width: '250px'}}>Status</td>
                                  <td style={{width: '20px', textAlign: 'center'}}>:</td>
                                  <td>{riderDetails?.status}</td>
                              </tr>
                              </tbody>
                          </table>
                      </div>
                  </div>
              </Loader>
          </div>
        </App>
      );
    }
  }
  
  export default withRouter(Details);
